import { render, staticRenderFns } from "./case-note-tags-select.vue?vue&type=template&id=5240eede"
import script from "./case-note-tags-select.vue?vue&type=script&lang=js"
export * from "./case-note-tags-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports